import React, { useEffect, useState } from 'react';

import { API } from 'constants';
import client from '../../../../services/library-api';

import Loading from '../../../../components/Loading';
import SendPlaneFillIcon from '../../../../design-system/Icons/SendPlaneFillIcon';
import WebhookNotificationsBlock from '../WebhookNotificationsBlock/WebhookNotificationsBlock';
import BlockContainerWithHeader from '../../../../components/BlockContainerWithHeader/BlockContainerWithHeader';
import { ButtonIcon, SvgIcon } from '../../../../design-system';
import { ArrowDownSLineIcon, ArrowUpSLineIcon } from '../../../../design-system/Icons';

const AgentNotifications = ({ agentId }) => {
    const [webhookNotifications, setWebhookNotifications] = useState(null);

    useEffect(() => {
        const fetchWebhookNotifications = async () => {
            try {
                setWebhookNotifications(null);

                const { data } = await client.get(API.ROUTES.library.process + agentId + '/event/');
                const filteredEvents =
                    data?.filter(
                        ({ delivery, event_listener }) =>
                            delivery === 'webhook' && event_listener === 'on_thread_success'
                    ) || [];

                setWebhookNotifications(filteredEvents);
            } catch (e) {
                setWebhookNotifications([]);
            }
        };

        void fetchWebhookNotifications();
    }, [agentId]);

    const [isExpanded, setIsExpanded] = useState(false);
    const icon = isExpanded ? ArrowUpSLineIcon : ArrowDownSLineIcon;

    const areEventsLoaded = !!webhookNotifications;

    return (
        <BlockContainerWithHeader
            title="Agent Notifications"
            description="Set up notifications to send when a job successfully completes for this Agent"
            containerGap={20}
        >
            <div className="px-4 py-3 w-full rounded-2 border-1 border-neutral-200 flex flex-col gap-4">
                <div className="flex items-center justify-between gap-3 cursor-pointer">
                    <div>
                        <div className="flex items-center gap-2 mb-0.5">
                            <SvgIcon color="#1F2125" icon={SendPlaneFillIcon} size="medium" />
                            <p className="font-body-bold text-body-bold-xs text-neytral-500">
                                Webhook
                            </p>
                        </div>
                        <p className="font-body text-body-regular-xs text-neutral-500">
                            Sends a webhook API request to the specified URL(s)
                        </p>
                    </div>

                    <ButtonIcon
                        type="neutral"
                        size="sm"
                        icon={icon}
                        onClick={() => setIsExpanded((prev) => !prev)}
                    />
                </div>

                {isExpanded && (
                    <div className="flex flex-col gap-3">
                        <p className="font-body text-body-regular-xs text-neutral-300 uppercase">
                            Notifications
                        </p>

                        {areEventsLoaded && (
                            <WebhookNotificationsBlock
                                agentId={agentId}
                                webhookNotifications={webhookNotifications}
                                setWebhookNotifications={setWebhookNotifications}
                            />
                        )}

                        {!areEventsLoaded && (
                            <div className="flex items-center justify-center">
                                <Loading withText={false} size="small" />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </BlockContainerWithHeader>
    );
};

export default AgentNotifications;
